// The AI Playground nav count (standing-agents task 21.7; spec "Waiting conversation stands
// out"): how many of the signed-in user's conversations wait on them — an open question from
// Orion, or a step parked for input or approval. Reseeded on mount, on hub reconnects, on any
// conversation or run-status nudge, and on the 30s fallback. `enabled: false` (planning off in
// this region, or the call failed) shows no count.

import { useCallback, useState } from 'react';
import type { AgentActivityEvent } from '@shared/api-types';
import { getWaitingCount } from './planningApi';
import { useStandingAgentLive } from '../pages/StandingAgents/useStandingAgentLive';

const OFF = { enabled: false, count: 0 };
const relevant = (e: AgentActivityEvent) => e.kind === 'conversation' || e.kind === 'status';

export function useWaitingConversations(): { enabled: boolean; count: number } {
  const [state, setState] = useState(OFF);
  const load = useCallback(async () => {
    try {
      const next = await getWaitingCount();
      setState(next && typeof next.enabled === 'boolean' ? { enabled: next.enabled, count: next.count ?? 0 } : OFF);
    } catch {
      setState(OFF);
    }
  }, []);
  useStandingAgentLive(load, { isRelevant: relevant });
  return state;
}
